module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/results01_sp-b5c321d933e7c43004d970f4d450a960.png";